import axios from "axios";
import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["select"];
  static values = {
    url: String,
    param: String
  }

  change(event){
    let targetValue = event.target.selectedOptions[0].value;
    let params = {}

    params[this.paramValue] = targetValue


    axios({url: this.urlValue, 
      method: 'GET', 
      params: params,
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(res=> {
      this.buildOptions(res.data.lab_sections)
    })
  
  }

  buildOptions(options){
    this.selectTarget.textContent = ''

    this.appendEmptyOption()

    options.forEach(el => {
      let option = document.createElement("option");
      option.text = el.label;
      option.value = el.id;
      this.selectTarget.appendChild(option)
    });

    $(this.selectTarget).selectpicker('refresh')
  }

  appendEmptyOption(){
    let option = document.createElement("option");
    option.text = ' ';

    this.selectTarget.appendChild(option)
  }
}
